import script from "./AdminSettlementsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettlementsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSettlementsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__